// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.range {
  display: flex;
  width: 100%;
  gap: 16px;
}
.range__label {
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  white-space: nowrap;
  width: 110px;
  display: flex;
  align-items: center;
}
.range__wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  position: relative;
  height: 49px;
  justify-content: center;
}
.range__wrapper_dimensions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 314px;
  position: relative;
  height: 49px;
  justify-content: center;
}
.range__input {
  -webkit-appearance: none;
  width: 100%;
  height: 4px;
  background: linear-gradient(to right, #629A33 0%, #629A33 50%, #629A33 50%);
  outline: none;
}
.range__input::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  background: #ffffff;
  border: 1px solid #629A33;
  box-shadow: 0px 6px 13px 0px rgba(71, 101, 147, 0.1607843137);
  box-shadow: 0px 0.5px 4px 0px rgba(71, 101, 147, 0.1607843137);
  cursor: pointer;
}
.range__input::-moz-range-thumb {
  width: 16px;
  height: 16px;
  background: #ffffff;
  border: 1px solid #629A33;
  box-shadow: 0px 6px 13px 0px rgba(71, 101, 147, 0.1607843137);
  box-shadow: 0px 0.5px 4px 0px rgba(71, 101, 147, 0.1607843137);
  border: none;
  cursor: pointer;
}
.range__input::-moz-range-track {
  width: 100%;
  height: 4px;
  background: transparent;
  border-radius: 5px;
}
.range__input::-ms-thumb {
  width: 16px;
  height: 16px;
  background: #629A33;
  cursor: pointer;
}
.range__input::-ms-track {
  width: 100%;
  height: 4px;
  background: transparent;
}
.range__input::-ms-fill-lower {
  background: #629A33;
  border-radius: 5px;
}
.range__input::-ms-fill-upper {
  background: #629A33;
  border-radius: 5px;
}
.range__input_dimensions {
  -webkit-appearance: none;
  width: 314px;
  height: 4px;
  background: linear-gradient(to right, #629A33 0%, #629A33 50%, #629A33 50%);
  outline: none;
  align-self: end;
}
.range__input_dimensions::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  background: #ffffff;
  border: 1px solid #629A33;
  box-shadow: 0px 6px 13px 0px rgba(71, 101, 147, 0.1607843137);
  box-shadow: 0px 0.5px 4px 0px rgba(71, 101, 147, 0.1607843137);
  cursor: pointer;
}
.range__input_dimensions::-moz-range-thumb {
  width: 16px;
  height: 16px;
  background: #ffffff;
  border: 1px solid #629A33;
  box-shadow: 0px 6px 13px 0px rgba(71, 101, 147, 0.1607843137);
  box-shadow: 0px 0.5px 4px 0px rgba(71, 101, 147, 0.1607843137);
  border: none;
  cursor: pointer;
}
.range__input_dimensions::-moz-range-track {
  width: 314px;
  height: 4px;
  background: transparent;
  border-radius: 5px;
  align-self: flex-end;
}
.range__input_dimensions::-ms-thumb {
  width: 16px;
  height: 16px;
  background: #629A33;
  cursor: pointer;
}
.range__input_dimensions::-ms-track {
  width: 314px;
  height: 4px;
  background: transparent;
  align-self: end;
}
.range__input_dimensions::-ms-fill-lower {
  background: #629A33;
  border-radius: 5px;
}
.range__input_dimensions::-ms-fill-upper {
  background: #629A33;
  border-radius: 5px;
}
.range__values {
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 400;
}
.range__values--min {
  text-align: left;
}
.range__values--max {
  text-align: right;
}
.range__value {
  font-size: 14px;
}
.range__thumb-value {
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  position: absolute;
  transform: translateY(40%);
  font-size: 14px;
  color: #111111;
  border-radius: 5px;
  white-space: nowrap;
  line-height: 18px;
  background-color: #ffffff;
}

.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;
  border: 1px solid #629A33;
  border-radius: 50px;
}
.switch .switch__input {
  opacity: 0;
  width: 0;
  height: 0;
}
.switch .switch__slider {
  display: flex;
  align-items: center;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: 0.4s;
  border-radius: 50px;
}
.switch .switch__slider:before {
  content: "";
  position: absolute;
  width: 47%;
  left: 1px;
  height: 90%;
  background-color: #629A33;
  border-radius: 50px;
  transition: 0.4s;
}
.switch .switch__input:checked + .switch__slider:before {
  transform: translateX(100%);
}
.switch .switch__input:disabled + .switch__slider {
  background-color: #ddd;
}
.switch .switch__input:disabled + .switch__slider:before {
  background-color: #bbb;
}

.direction {
  display: flex;
  justify-content: space-between;
}

.direction__switch {
  display: flex;
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
}
.direction__switch > :not(:last-child) {
  margin-right: 20px;
}

.switch_active {
  color: #629A33;
}`, "",{"version":3,"sources":["webpack://./src/components/interface/interfaceItems/interfaceGroup/interfaceGroupInputs/range/generateRange.scss","webpack://./src/styles/_mixins.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,WAAA;EACA,SAAA;AAFF;AAIE;EC8BA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ED/BE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AACJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;AAFJ;AAKE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;AAHJ;AAME;EACE,wBAAA;EACA,WAAA;EACA,WAAA;EACA,2EAAA;EAIA,aAAA;AAPJ;AAUI;EACE,wBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBE9CQ;EF+CR,yBAAA;EACA,6DAAA;EACA,8DAAA;EACA,eAAA;AARN;AAaI;EACE,WAAA;EACA,YAAA;EACA,mBE1DQ;EF2DR,yBAAA;EACA,6DAAA;EACA,8DAAA;EACA,YAAA;EACA,eAAA;AAXN;AAcI;EACE,WAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;AAZN;AAgBI;EACE,WAAA;EACA,YAAA;EACA,mBElFS;EFmFT,eAAA;AAdN;AAiBI;EACE,WAAA;EACA,WAAA;EACA,uBAAA;AAfN;AAkBI;EACE,mBE7FS;EF8FT,kBAAA;AAhBN;AAmBI;EACE,mBElGS;EFmGT,kBAAA;AAjBN;AAqBE;EACE,wBAAA;EACA,YAAA;EACA,WAAA;EACA,2EAAA;EAIA,aAAA;EACA,eAAA;AAtBJ;AAyBI;EACE,wBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBEnHQ;EFoHR,yBAAA;EACA,6DAAA;EACA,8DAAA;EACA,eAAA;AAvBN;AA4BI;EACE,WAAA;EACA,YAAA;EACA,mBE/HQ;EFgIR,yBAAA;EACA,6DAAA;EACA,8DAAA;EACA,YAAA;EACA,eAAA;AA1BN;AA6BI;EACE,YAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;AA3BN;AA+BI;EACE,WAAA;EACA,YAAA;EACA,mBExJS;EFyJT,eAAA;AA7BN;AAgCI;EACE,YAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;AA9BN;AAiCI;EACE,mBEpKS;EFqKT,kBAAA;AA/BN;AAkCI;EACE,mBEzKS;EF0KT,kBAAA;AAhCN;AAoCE;EC3IA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ED0IE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;AA/BJ;AAiCI;EACE,gBAAA;AA/BN;AAkCI;EACE,iBAAA;AAhCN;AAoCE;EACE,eAAA;AAlCJ;AAqCE;EC/JA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EAlCA,2BAAA;EDiME,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBEzMU;AFyKd;;AAoCA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AAjCF;AAmCE;EACE,UAAA;EACA,QAAA;EACA,SAAA;AAjCJ;AAoCE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AAlCJ;AAoCI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,yBElPS;EFmPT,mBAAA;EACA,gBAAA;AAlCN;AAuCI;EACE,2BAAA;AArCN;AAyCE;EACE,sBAAA;AAvCJ;AAyCI;EACE,sBAAA;AAvCN;;AA4CA;EACE,aAAA;EACA,8BAAA;AAzCF;;AA4CA;EACE,aAAA;EC1OA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ADkMF;AAwCE;EACE,kBAAA;AAtCJ;;AA0CA;EACE,cEtRa;AF+Of","sourcesContent":["@use \"../../../../../../styles/mixins\" as mixins;\n@use \"../../../../../../styles/variables\" as vars;\n\n.range {\n  display: flex;\n  width: 100%;\n  gap: 16px;\n\n  &__label {\n    @include mixins.h3();\n    white-space: nowrap;\n    width: 110px;\n    display: flex;\n    align-items: center;\n    // min-width: 25%;\n    // color: vars.$second-color;\n  }\n\n  &__wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    width: 100%;\n    position: relative;\n    height: 49px;\n    justify-content: center;\n  }\n\n  &__wrapper_dimensions {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    width: 314px;\n    position: relative;\n    height: 49px;\n    justify-content: center;\n  }\n\n  &__input {\n    -webkit-appearance: none;\n    width: 100%;\n    height: 4px;\n    background: linear-gradient(to right,\n        vars.$second-color 0%,\n        vars.$second-color 50%,\n        vars.$second-color 50%);\n    outline: none;\n\n    // Для хрома\n    &::-webkit-slider-thumb {\n      -webkit-appearance: none;\n      appearance: none;\n      width: 16px;\n      height: 16px;\n      background: vars.$white-color;\n      border: 1px solid vars.$second-color;\n      box-shadow: 0px 6px 13px 0px #47659329;\n      box-shadow: 0px 0.5px 4px 0px #47659329;\n      cursor: pointer;\n\n    }\n\n    // Для Firefox\n    &::-moz-range-thumb {\n      width: 16px;\n      height: 16px;\n      background: vars.$white-color;\n      border: 1px solid vars.$second-color;\n      box-shadow: 0px 6px 13px 0px #47659329;\n      box-shadow: 0px 0.5px 4px 0px #47659329;\n      border: none;\n      cursor: pointer;\n    }\n\n    &::-moz-range-track {\n      width: 100%;\n      height: 4px;\n      background: transparent;\n      border-radius: 5px;\n    }\n\n    // IE Edge\n    &::-ms-thumb {\n      width: 16px;\n      height: 16px;\n      background: vars.$second-color;\n      cursor: pointer;\n    }\n\n    &::-ms-track {\n      width: 100%;\n      height: 4px;\n      background: transparent;\n    }\n\n    &::-ms-fill-lower {\n      background: vars.$second-color;\n      border-radius: 5px;\n    }\n\n    &::-ms-fill-upper {\n      background: vars.$second-color;\n      border-radius: 5px;\n    }\n  }\n\n  &__input_dimensions {\n    -webkit-appearance: none;\n    width: 314px;\n    height: 4px;\n    background: linear-gradient(to right,\n        vars.$second-color 0%,\n        vars.$second-color 50%,\n        vars.$second-color 50%);\n    outline: none;\n    align-self: end;\n\n    // Для хрома\n    &::-webkit-slider-thumb {\n      -webkit-appearance: none;\n      appearance: none;\n      width: 16px;\n      height: 16px;\n      background: vars.$white-color;\n      border: 1px solid vars.$second-color;\n      box-shadow: 0px 6px 13px 0px #47659329;\n      box-shadow: 0px 0.5px 4px 0px #47659329;\n      cursor: pointer;\n\n    }\n\n    // Для Firefox\n    &::-moz-range-thumb {\n      width: 16px;\n      height: 16px;\n      background: vars.$white-color;\n      border: 1px solid vars.$second-color;\n      box-shadow: 0px 6px 13px 0px #47659329;\n      box-shadow: 0px 0.5px 4px 0px #47659329;\n      border: none;\n      cursor: pointer;\n    }\n\n    &::-moz-range-track {\n      width: 314px;\n      height: 4px;\n      background: transparent;\n      border-radius: 5px;\n      align-self: flex-end;\n    }\n\n    // IE Edge\n    &::-ms-thumb {\n      width: 16px;\n      height: 16px;\n      background: vars.$second-color;\n      cursor: pointer;\n    }\n\n    &::-ms-track {\n      width: 314px;\n      height: 4px;\n      background: transparent;\n      align-self: end;\n    }\n\n    &::-ms-fill-lower {\n      background: vars.$second-color;\n      border-radius: 5px;\n    }\n\n    &::-ms-fill-upper {\n      background: vars.$second-color;\n      border-radius: 5px;\n    }\n  }\n\n  &__values {\n    @include mixins.h3();\n    display: flex;\n    justify-content: space-between;\n    font-size: 14px;\n    font-weight: 400;\n\n    &--min {\n      text-align: left;\n    }\n\n    &--max {\n      text-align: right;\n    }\n  }\n\n  &__value {\n    font-size: 14px;\n  }\n\n  &__thumb-value {\n    @include mixins.h3();\n    @include mixins.font-family();\n    font-size: 14px;\n    font-weight: 400;\n    position: absolute;\n    transform: translateY(40%);\n    font-size: 14px;\n    color: #111111;\n    border-radius: 5px;\n    white-space: nowrap;\n    line-height: 18px;\n    background-color: vars.$white-color;\n  }\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 22px;\n  border: 1px solid vars.$second-color;\n  border-radius: 50px;\n\n  .switch__input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n  }\n\n  .switch__slider {\n    display: flex;\n    align-items: center;\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    transition: 0.4s;\n    border-radius: 50px;\n\n    &:before {\n      content: \"\";\n      position: absolute;\n      width: 47%;\n      left: 1px;\n      height: 90%;\n      background-color: vars.$second-color;\n      border-radius: 50px;\n      transition: 0.4s;\n    }\n  }\n\n  .switch__input:checked+.switch__slider {\n    &:before {\n      transform: translateX(100%);\n    }\n  }\n\n  .switch__input:disabled+.switch__slider {\n    background-color: #ddd;\n\n    &:before {\n      background-color: #bbb;\n    }\n  }\n}\n\n.direction {\n  display: flex;\n  justify-content: space-between;\n}\n\n.direction__switch {\n  display: flex;\n  @include mixins.h3();\n\n  &> :not(:last-child) {\n    margin-right: 20px;\n  }\n}\n\n.switch_active {\n  color: vars.$second-color;\n}","@use \"variables\" as vars;\n\n@mixin text-center {\n  text-align: center;\n}\n\n@mixin font-family {\n  font-family: \"Inter\", serif;\n}\n\n@mixin font-family-second {\n   font-family: \"Inter\", serif;\n}\n\n@mixin box-border($blur, $color) {\n  border: 0.5px solid $color;\n}\n\n@mixin box-border-solid($blur, $color) {\n  border: 1px solid $color;\n}\n\n@mixin box-shadow($color) {\n  box-shadow: 0px 0px 20px 0px rgba($color, 0.1);\n}\n\n@mixin radius() {\n  border-radius: 10px;\n}\n\n@mixin h2() {\n  font-family: \"Inter\", serif;\n  font-weight: 300;\n  font-size: 17px;\n  line-height: 100%;\n}\n\n@mixin h3() {\n  font-family: \"Inter\", serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n}\n\n@mixin h4() {\n  font-family: \"Inter\", serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n@mixin h5() {\n  font-family: \"Inter\", serif;\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  text-align: center;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n@mixin bold {\n  font-family: \"Inter\", serif;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 12px;\n}\n","$primary-color: #629A33;\n$secondary-color: #6c757d;\n$font-size-base: 16px;\n$second-color: #629A33;\n$second-color-1: #06aeef;\n$shadow-color: #47659314;\n$black-color:  #1A1A1A;\n$black-color-second: #3A3A3C;\n$white-color: #ffffff;\n$red-color: #ff214a;\n\n$margin-top-title-option: 10px;\n$padding-vertical-group-inputs: 20px;\n$width-interface: 39vw;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
